export const FIELDS_MISSING = 'fields missing';
export const INVALID_PERMISSIONS = 'INVALID_PERMISSIONS';
export const DATA_CONFLICT = 'DATA_CONFLICT';
export const ALREADY_EXISTS = 'ALREADY_EXISTS';
export const INVALID_FIELD = 'INVALID_FIELD';
export const NO_LICENSE_PACK = 'NO_LICENSE_PACK';
